<app-header></app-header>

<div class="min-h-screen tema-claro">
  <div class="max-w-2xl mx-auto p-6">

    <!-- Breadcrumb -->
    <div class="mb-6 flex items-center gap-2 text-xs" style="color: var(--tx-2)">
      <a routerLink="/home" class="hover:underline" style="color: var(--brand-primary)">Início</a>
      <span>/</span>
      <a routerLink="/lancamentos-financeiros" class="hover:underline" style="color: var(--brand-primary)">Lançamentos Financeiros</a>
      <span>/</span>
      <span class="font-semibold" style="color: var(--tx)">Estacionamento</span>
    </div>

    <!-- Card principal -->
    <div class="bg-white rounded-2xl shadow-sm overflow-hidden" style="border: 1px solid var(--flua-borda)">

      <!-- Header roxo -->
      <div class="px-6 py-4 flex items-center justify-between" style="background-color: var(--thead)">
        <div class="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
               stroke-width="1.5" stroke="white" class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z"/>
          </svg>
          <span class="font-semibold text-sm text-white">Estacionamento — Recebimento</span>
        </div>
        <button (click)="voltar()" class="p-1 text-white hover:opacity-75">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
               stroke-width="2" stroke="currentColor" class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Sucesso -->
      <div *ngIf="sucesso" class="px-6 py-8 text-center">
        <div class="mx-auto w-14 h-14 rounded-full flex items-center justify-center mb-3" style="background-color: #dcfce7">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" style="stroke: var(--brand-secondary)" class="size-7">
            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
          </svg>
        </div>
        <p class="font-semibold text-sm mb-1" style="color: var(--tx)">Estacionamento registrado com sucesso!</p>
        <p class="text-xs" style="color: var(--tx-2)">
          Comprovante nº <strong style="color: var(--tx)">{{ sucesso.nrSequencia }}</strong> —
          <strong style="color: #00AC70">{{ formatCurrency(sucesso.valor) }}</strong>
        </p>
        <div class="mt-6 flex justify-center gap-2 flex-wrap">
          <button (click)="imprimirRecibo()"
                  class="px-4 py-2 rounded-lg text-xs font-semibold flex items-center gap-1.5"
                  style="border: 1px solid var(--brand-primary); color: var(--brand-primary); background-color: var(--cartao)"
                  onmouseover="this.style.backgroundColor='#F9F5EC'"
                  onmouseout="this.style.backgroundColor='white'">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="2" stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"/>
            </svg>
            Imprimir Recibo
          </button>
          <button (click)="novoRegistro()"
                  class="px-4 py-2 rounded-lg text-xs font-semibold"
                  style="border: 1px solid var(--flua-borda); color: var(--tx-2)">
            Novo Registro
          </button>
          <button (click)="voltar()"
                  class="px-4 py-2 rounded-lg text-xs font-semibold text-white"
                  style="background-color: var(--brand-primary)"
                  onmouseover="this.style.backgroundColor='var(--brand-ink)'"
                  onmouseout="this.style.backgroundColor='var(--brand-primary)'">
            Voltar
          </button>
        </div>
      </div>

      <!-- Corpo -->
      <div *ngIf="!sucesso" class="px-6 py-5 space-y-4">

        <!-- Valor destacado -->
        <div class="rounded-lg p-4 text-center" style="background-color: var(--flua-rodape); border: 1px solid var(--flua-borda)">
          <p class="text-xs mb-1" style="color: var(--tx-2)">Valor do recebimento</p>
          <div class="flex items-center justify-center gap-1">
            <span class="text-lg font-bold" style="color: var(--brand-primary)">R$</span>
            <input type="number" step="0.01" min="0"
                   [(ngModel)]="valor"
                   placeholder="0,00"
                   class="text-2xl font-bold text-center border-b-2 bg-transparent outline-none"
                   style="color: var(--brand-primary); border-color: var(--flua-borda); width: 200px"
                   (focus)="$any($event.target).select()"/>
          </div>
        </div>

        <!-- Caixa -->
        <div>
          <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Caixa</label>
          <select [(ngModel)]="caixa"
                  (ngModelChange)="onCaixaChange()"
                  class="w-full px-3 py-2 text-sm rounded-lg"
                  style="border: 1px solid var(--flua-borda); color: var(--tx)">
            <option *ngFor="let c of caixas" [ngValue]="c">
              {{ c.name }} — {{ c.establishmentName }}
            </option>
          </select>
        </div>

        <!-- Pessoa Física (typeahead) -->
        <div class="relative">
          <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Pessoa Física *</label>
          <div class="relative">
            <input type="text"
                   [(ngModel)]="pessoaTermo"
                   (ngModelChange)="onPessoaTermoChange()"
                   (focus)="showPessoaDropdown = pessoaResultados.length > 0"
                   placeholder="Digite nome ou CPF (mín. 3 caracteres)"
                   class="w-full px-3 py-2 text-sm rounded-lg pr-9"
                   style="border: 1px solid var(--flua-borda); color: var(--tx)"/>
            <div class="absolute right-3 top-1/2 -translate-y-1/2">
              <svg *ngIf="!isSearchingPessoa" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                   stroke-width="2" stroke="#4A5D6B" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/>
              </svg>
              <div *ngIf="isSearchingPessoa" class="animate-spin rounded-full h-4 w-4 border-b-2" style="border-color: var(--brand-primary)"></div>
            </div>
          </div>
          <div *ngIf="showPessoaDropdown && pessoaResultados.length > 0"
               class="absolute left-0 right-0 z-10 mt-1 rounded-lg shadow-lg overflow-auto bg-white"
               style="border: 1px solid var(--flua-borda); max-height: 200px">
            <button *ngFor="let p of pessoaResultados"
                    type="button"
                    (click)="selecionarPessoa(p)"
                    class="w-full text-left px-3 py-2 text-xs hover:bg-gray-50"
                    style="border-bottom: 1px solid #F4F1EA; color: var(--tx)">
              <div class="font-semibold">{{ p.nmPessoaFisica }}</div>
              <div class="text-[11px]" style="color: var(--tx-2)">
                Código: {{ p.cdPessoaFisica }}
                <span *ngIf="p.nrCpf"> — CPF: {{ p.nrCpf }}</span>
              </div>
            </button>
          </div>
          <p *ngIf="pessoaId" class="text-[10px] mt-1" style="color: #00AC70">
            ✓ Paciente selecionado (código {{ pessoaId }})
          </p>
        </div>

        <!-- Centro de Custo (dropdown) -->
        <div>
          <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Centro de Custo *</label>
          <select [(ngModel)]="centroCustoSelecionado"
                  [disabled]="isLoadingCentros"
                  class="w-full px-3 py-2 text-sm rounded-lg"
                  style="border: 1px solid var(--flua-borda); color: var(--tx)">
            <option [ngValue]="null" disabled>
              {{ isLoadingCentros ? 'Carregando...' : 'Selecione...' }}
            </option>
            <option *ngFor="let cc of centrosCusto" [ngValue]="cc">
              {{ cc.cdCentroCusto }} — {{ cc.dsCentroCusto }}
            </option>
          </select>
          <p *ngIf="!isLoadingCentros && centrosCusto.length === 0 && caixa"
             class="text-[10px] mt-1" style="color: #991b1b">
            Nenhum centro de custo encontrado para este estabelecimento.
          </p>
        </div>

        <!-- Observação -->
        <div>
          <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Observação (opcional)</label>
          <input type="text" maxlength="200"
                 [(ngModel)]="observacao"
                 (focus)="onObservacaoFocus()"
                 class="w-full px-3 py-2 text-sm rounded-lg"
                 style="border: 1px solid var(--flua-borda); color: var(--tx)"/>
        </div>

        <!-- Data Transação -->
        <div>
          <label class="text-xs font-semibold mb-2 block" style="color: var(--tx)">Data Transação</label>
          <input type="datetime-local"
                 [(ngModel)]="dataTransacao"
                 readonly
                 class="w-full px-3 py-2 text-sm rounded-lg"
                 style="border: 1px solid var(--flua-borda); color: var(--tx-2); background-color: var(--flua-rodape)"/>
        </div>

        <!-- Erro -->
        <div *ngIf="erro"
             class="rounded-lg px-3 py-2 text-xs flex items-start gap-2"
             style="background-color: #fef2f2; border: 1px solid #fecaca; color: #991b1b">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
               stroke-width="2" stroke="#991b1b" class="size-4 flex-shrink-0 mt-0.5">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
          </svg>
          <span>{{ erro }}</span>
        </div>

      </div>

      <!-- Footer -->
      <div *ngIf="!sucesso" class="px-6 py-4 flex justify-end gap-2" style="border-top: 1px solid var(--flua-borda)">
        <button (click)="voltar()"
                class="px-4 py-2 rounded-lg text-xs font-semibold"
                style="border: 1px solid var(--flua-borda); color: var(--tx-2)">
          Cancelar
        </button>
        <button (click)="registrar()"
                [disabled]="!formValido() || isSubmitting"
                class="px-5 py-2 rounded-lg text-xs font-semibold text-white flex items-center gap-1.5"
                [style.backgroundColor]="!formValido() || isSubmitting ? '#D6CFC2' : 'var(--brand-primary)'"
                [style.cursor]="!formValido() || isSubmitting ? 'not-allowed' : 'pointer'">
          <div *ngIf="isSubmitting" class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
          {{ isSubmitting ? 'Registrando...' : 'Registrar' }}
        </button>
      </div>
    </div>
  </div>
</div>
